import React from 'react';
import { useRouter } from 'next/router';

import { PageId } from 'utils/ubi/pageId';

import InternalLink, { LinkProps } from './InternalLink';

const articleLink = (slug: string, isPlain: boolean) => (market: string) =>
  `/${market}/article/${slug}/${isPlain ? 'plain/' : ''}`;

interface ArticleLinkProps extends LinkProps {
  slug: string;
}

const ArticleLink = ({ slug, ...props }: ArticleLinkProps) => {
  const isPlain = useRouter().asPath.includes('/plain/');
  return <InternalLink toPage={PageId.Article} hrefFun={articleLink(slug, isPlain)} {...props} />;
};

export default ArticleLink;
